module.exports = __webpack_public_path__ + "media/请美女换位思考.2cdf91f5.mp3";